import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import {
  createPaymentCategory,
  getPaymentCategory,
} from "../../../../api/financial";

export default (props) => {
  const ref = React.useRef();
  const [show, setShow] = React.useState(false);
  const [name, setName] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [categories, setCategories] = React.useState([]);

  function openModal() {
    setShow(true);
  }
  function closeModal() {
    setName("");
    setLoading(false);
    setShow(false);
  }
  function onChange(e) {
    if (props.onChange) {
      props.onChange({
        target: { name: "category", value: e.target.value },
      });
    }
  }

  function onSave() {
    if (loading) {
      return;
    }
    setLoading(true);
    createPaymentCategory(name)
      .then((category) => {
        setCategories([category, ...categories]);
        setTimeout(() => {
          onChange({ target: { value: category.id } });
          setLoading(false);
          closeModal();
        }, 400);
      })
      .catch((error) => { });
  }
  function onInit() {
    setLoading(true);
    getPaymentCategory()
      .then((data) => setCategories(data))
      .finally((error) => {
        setTimeout(() => setLoading(false), 1000);
      });
  }
  React.useEffect(onInit, [ref.current]);

  return (
    <div ref={ref}>
      <Text color="primary">{props.title}</Text>
      <LoadingInput onChange={onChange} loading={loading} as="select">
        <option selected>
          Sem Categoria
        </option>
        {categories.map((category) => (
          <option
            selected={props.selected == category.id}
            key={category.id}
            value={category.id}
          >
            {category.name}
          </option>
        ))}
      </LoadingInput>
      {
        props.allowCreate ?
          <Button as="text" className='text-secondary' onClick={openModal}>
            Criar Categoria
          </Button>
          :
          <React.Fragment />
      }

      <Modal
        title="Criar categoria de pagamento"
        show={show}
        onHide={closeModal}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <div className="form-group">
                <div className="form-label">
                  <Text color="primary">Nome da categoria</Text>
                </div>
                <LoadingInput
                  name="name"
                  loading={loading}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <Button disabled={loading || name.length < 4} onClick={onSave}>
                Cadastrar
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/PaymentCategory/index.jsx